export default "__VITE_ASSET__Dvu9Ma1e__"